import {useExternalControls} from "laravel-inertia-backend";
import HeaderNavExtraComponent from "./HeaderNavExtraComponent.jsx";
import SupportHeaderControl from "./Support/SupportHeaderControl.jsx";
import SupportSidebarControl from "./Support/SupportSidebarControl.jsx";
import {version} from "../version.js";
import {useEffect} from "react";

export default function GlobalControls(props) {

    const context = useExternalControls();

    useEffect(() => {
        // Die Cronjob-Bedienelemente sind nur für Admins sichtbar (die
        // Komponente entscheidet das selbst); das Support-Icon dahinter gilt
        // für alle und rückt per ms-auto ans rechte Ende der Leiste, direkt
        // neben den Benutzernamen.
        context.setHeaderControls(
            <>
                <HeaderNavExtraComponent />
                <SupportHeaderControl />
            </>
        );
        // Fußbereich der Seitenleiste: "Tickets" (nur bei Freischaltung,
        // siehe SupportSidebarControl) und darunter die Versionsnummer.
        context.setSidebarControls(
            <div className="sidebar-footer-controls">
                <SupportSidebarControl />
                <div className="sidebar-footer-version">Version: {version}</div>
            </div>
        );
    }, []);

    return null;
}
